import { useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import {
  DialogContent,
  DialogContentText,
  Grid,
  Button,
  Box,
} from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import CustomButton from "../../../../components/common/button/CustomButton";
import ManageQuickBook from "./ManageQuickBook";

interface ManageQuickBookProps {
  open: boolean;
  onHide: () => void;
  title: string;
  selectData?: any;
}

const ManageSelectFinancial = (props: ManageQuickBookProps) => {
  const { selectData, onHide, open, title } = props;
  const classes = useStyles();

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs");

  const hideHandler = () => {
    onHide();
  };

  const [quickBooksSelected, setQuickBooksSelected] = useState(false);
  const [xeroSelected, setXeroSelected] = useState(false);

  const handleQuickBooksClick = () => {
    console.log("QuickBooks clicked", selectData);
    setQuickBooksSelected(true);
    setXeroSelected(false);
    // Add your logic here
  };

  const handleXeroClick = () => {
    console.log("Xero clicked", selectData);
    setQuickBooksSelected(false);
    setXeroSelected(true);
    // Add your logic here
  };

  return (
    <>
    <Popup
      open={open}
      title={title}
      onHide={hideHandler}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      popupBg="#fff"
      header={
        <img
          onClick={hideHandler}
          src={closeIcon}
          className={classes.closeicons}
          alt="close"
        />
      }
    >
      <DialogContent sx={{ padding: "10px" }}>
        <DialogContentText>
          <>
            {/* Buttons Section */}
            <Box display="flex" justifyContent="center" mt={2}>
              <CustomButton
                variant="contained"
                onClick={handleQuickBooksClick}
                sx={{ mr: 4 }}
                title="QuickBooks"
              />
              <CustomButton
                disabled
                variant="contained"
                onClick={handleXeroClick}
                // sx={{ mr: 4 }}
                title="Xero"
              />
            </Box>
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
    {quickBooksSelected && (
        <ManageQuickBook
          open={open}
          onHide={() => setQuickBooksSelected(false)}
          title={"Add Financial"}
          selectData={null}
        />
        )}
    </>
  );
};

export default ManageSelectFinancial;
